import { Routes } from '@angular/router';
import { mechanicCategoriseRoutes } from './categorise/routes';
import { mechanicOddOneOutRoutes } from './odd-one-out/routes';
import { SortingPage } from './sorting-page';
import { mechanicYesOrNoRoutes } from './yes-no/routes';

export const mechanicSortingRoutes: Routes = [
  {
    path: '',
    component: SortingPage,
  },
  {
    path: 'categorise',
    children: mechanicCategoriseRoutes,
  },
  {
    path: 'yes-or-no',
    children: mechanicYesOrNoRoutes,
  },
  {
    path: 'odd-one-out',
    children: mechanicOddOneOutRoutes,
  },
];
